import moment from "moment";
import React, { useState, useEffect } from "react";
import Button from "../../../components/Button";
import InputDate from "../../../components/InputDate";
import InputSelect from "../../../components/InputSelect";
import Modal from "../../../components/Modal";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";

export const ModalFilter = ({showFilter, setShowFilter, filters, setCustomFilters}) => {
    const [admins, setAdmins] = useState([]);
    const [admin, setAdmin] = useState(null);
    const [initDate, setInitDate] = useState(null);
    const [finalDate, setFinalDate] = useState(null);

    useEffect(() => {
        getAdmins();
    }, []);

    useEffect(() => {
        if (!showFilter) return;

        setAdmin(filters.adminId);
        setInitDate(filters.createdFrom ? moment(filters.createdFrom).format('YYYY-MM-DD') : null);
        setFinalDate(filters.createdTo ? moment(filters.createdTo).format('YYYY-MM-DD') : null);
    }, [showFilter, filters]);

    const getAdmins = () => {
        api.get(`/list`).then(res => {
            setAdmins(res.data.resources);
        });
    }
    
    const handleClear = () => {
        setCustomFilters({
            adminId: null,
            createdFrom: null,
            createdTo: null,
        });
        setAdmin(null);
        setInitDate(null);
        setFinalDate(null);
        setShowFilter(false);
    }

    const handleFilter = () => {
        setCustomFilters({
            adminId: admin,
            createdFrom: initDate ? moment(initDate).format('YYYY-MM-DD') : null,
            createdTo: finalDate ? moment(finalDate).format('YYYY-MM-DD') : null,
        });
        setShowFilter(false);
    }
    
    return (
        <Modal
            show={showFilter}
            close={() => setShowFilter(false)}
            title={`Filtrar`}
            footer={
                <>
                    <Button
                        type={`secondary`}
                        size={`small`}
                        text={`Limpar filtros`}
                        action={handleClear}
                    />
                    <Button
                        type={`primary`}
                        size={`small`}
                        text={`Filtrar resultados`}
                        action={handleFilter}
                    />
                    
                </>
            }
        >
            <div className="section">
                <div className="row">
                    <div className="col">
                        <InputSelect label={`Responsável`} options={createOptions(admins, 'name', 'id', true, null, 'Todos')} value={admin} change={setAdmin} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <InputDate
                            value={initDate}
                            change={setInitDate}
                            label={`Data inicial`}
                        />
                    </div>
                    <div className="col-6">
                        <InputDate
                            value={finalDate}
                            change={setFinalDate}
                            label={`Data final`}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}
